import CommonButton from 'components/Buttons/CommonButton';
import SearchInput from 'components/Input/SearchInput';
import { IFilterValue } from 'models/request';
import { IFilterDinamicForm } from 'models/response';
import React from 'react';
import styled from 'styled-components/macro';
import utils from 'utils';
import { getInputValue, handleTextInputChange } from '../utils';
import { useSelector } from 'react-redux';
import { actionType } from 'utils/constants';
import { RootState } from 'models';
import selectors from 'state/selectors';
import { useTheme } from 'providers/ThemeProvider';

interface Props {
  filter: IFilterDinamicForm;
  filterValues: IFilterValue[];
  setFilterValues: React.Dispatch<React.SetStateAction<IFilterValue[]>>;
  onSearch: (filterValues: IFilterValue[]) => void;
  filterErrors: { [key: string]: string };
  filters: IFilterDinamicForm[];
  setFilterErrors: React.Dispatch<React.SetStateAction<{ [key: string]: string }>>;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const InputWrapper = styled.div`
  width: 300px;
`;

const Label = styled.div`
  font-size: large;
  margin: 20px 0px;
  text-align: center;
  width: 100%;
  color: ${({ theme }) => theme.colorPalette.isDarkMode && 'white'};
`;

const SearchBarFilter = (props: Props) => {
  const { filter, filterValues, setFilterValues, onSearch, filterErrors, filters, setFilterErrors } = props;
  const t = utils.intl.useTranslator();
  const { val: HIDE_SEARCH_ALL } = useSelector((store: RootState) =>
    selectors.app.getConfig(store, actionType.HIDE_SEARCH_ALL, 0),
  );
  const { isDarkMode } = useTheme();
  return (
    <>
      <Container>
        <Label>{t(filter.label)}</Label>
        <InputWrapper>
          <SearchInput
            placeholder={t(filter.inputProp?.placeHolder || 'search')}
            fullWidth
            style={{
              color: 'black',
            }}
            value={getInputValue(filter, filterValues)}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleTextInputChange(
                filter,
                e.target.value,
                filterValues,
                setFilterValues,
                filterErrors,
                filters,
                setFilterErrors,
              )
            }
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                onSearch(filterValues);
              }
            }}
            bgColor={'white'}
          />
        </InputWrapper>
      </Container>
      <CommonButton
        id="search-btn"
        value={t('search')}
        action={() => onSearch(filterValues)}
        style={{ alignSelf: 'flex-end' }}
        disabled={!getInputValue(filter, filterValues).length}
      />
      {!HIDE_SEARCH_ALL && (
        <CommonButton
          id="search-all-btn"
          value={t('allContracts')}
          action={() => onSearch([])}
          style={{ alignSelf: 'flex-end' }}
          selected={isDarkMode}
          scope={isDarkMode ? 'quaternary' : 'secondary'}
        />
      )}
    </>
  );
};
export default SearchBarFilter;
